import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { DEFAULT_LOCALE, type Locale } from "./locales";

import enAthleteManager from "../../locales/en/athleteManager.json";
import enOfficials from "../../locales/en/officials.json";
import enParaSupport from "../../locales/en/paraSupport.json";
import enRecords from "../../locales/en/records.json";
import enReports from "../../locales/en/reports.json";
import enAthletes from "../../locales/en/athletes.json";
import enAttempts from "../../locales/en/attempts.json";
import enBench from "../../locales/en/bench.json";
import enAuth from "../../locales/en/auth.json";
import enBout from "../../locales/en/bout.json";
import enCommon from "../../locales/en/common.json";
import enControl from "../../locales/en/control.json";
import enDashboard from "../../locales/en/dashboard.json";
import enErrors from "../../locales/en/errors.json";
import enGeneric from "../../locales/en/generic.json";
import enHome from "../../locales/en/home.json";
import enJudged from "../../locales/en/judged.json";
import enLifts from "../../locales/en/lifts.json";
import enMedals from "../../locales/en/medals.json";
import enMeet from "../../locales/en/meet.json";
import enMeetsList from "../../locales/en/meetsList.json";
import enNav from "../../locales/en/nav.json";
import enNocs from "../../locales/en/nocs.json";
import enSets from "../../locales/en/sets.json";
import enStandings from "../../locales/en/standings.json";
import enStartList from "../../locales/en/startList.json";
import enTeams from "../../locales/en/teams.json";
import enRounds from "../../locales/en/rounds.json";
import enTimed from "../../locales/en/timed.json";
import enStreams from "../../locales/en/streams.json";

export { intlLocaleFor, SUPPORTED_LOCALES, type Locale } from "./locales";

/**
 * OVR is English only: these bundles are every string the app shows, and the
 * source `types.d.ts` derives the typed t() keys from.
 *
 * Adding a namespace: create `locales/en/<ns>.json`, import it here, add it
 * to EN_RESOURCES and to `types.d.ts`.
 */
export const EN_RESOURCES = {
	athletes: enAthletes,
	athleteManager: enAthleteManager,
	officials: enOfficials,
	paraSupport: enParaSupport,
	records: enRecords,
	reports: enReports,
	attempts: enAttempts,
	bench: enBench,
	auth: enAuth,
	bout: enBout,
	common: enCommon,
	control: enControl,
	dashboard: enDashboard,
	errors: enErrors,
	generic: enGeneric,
	home: enHome,
	judged: enJudged,
	lifts: enLifts,
	medals: enMedals,
	meet: enMeet,
	meetsList: enMeetsList,
	nav: enNav,
	nocs: enNocs,
	sets: enSets,
	standings: enStandings,
	startList: enStartList,
	teams: enTeams,
	timed: enTimed,
	streams: enStreams,
	rounds: enRounds,
} as const;

/** The active locale for anything outside React: always English. */
export function currentLocale(): Locale {
	return DEFAULT_LOCALE;
}

/** Runs before the first render (main.tsx) so no frame paints untranslated. */
export async function initI18n(): Promise<void> {
	await i18n.use(initReactI18next).init({
			lng: DEFAULT_LOCALE,
			fallbackLng: DEFAULT_LOCALE,
			ns: Object.keys(EN_RESOURCES),
			defaultNS: "common",
			resources: { en: EN_RESOURCES },
			interpolation: { escapeValue: false }, // React escapes already
			react: { useSuspense: false }, // init awaits the bundles instead
			returnNull: false,
		});
	document.documentElement.lang = DEFAULT_LOCALE;
}

export { i18n };
